import React, { useEffect, useState, useContext } from 'react';
import './SearchBar.css'

export default function SearchBar({onSearch}) {
    return (
        <div>
            <input class="search" placeholder="Search..." onChange={(e) => onSearch(e.target.value)}></input>
        </div>
    )
}